import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const noDataContent: SxStyle = {
  height: (p) => p.spacing(25),
  width: '100%',
};

export const emptyIconBox: SxStyle = {
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(2),
  padding: (p) => p.spacing(0.75),
  display: 'inline-block',
};

export const emptyIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
export const noDataTitleBox: SxStyle = {
  position: 'relative',
  width: (p) => p.spacing(25),
  height: (p) => p.spacing(5),
};

export const noDataTitleBox1: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(5),
  width: (p) => p.spacing(25),
  height: (p) => p.spacing(5),
  top: (p) => p.spacing(2),
};
export const noDataTitleBox2: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(2),
  width: (p) => p.spacing(25),
  height: (p) => p.spacing(5),
  top: (p) => p.spacing(1),
};

export const emptyIconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  outlineWidth: (p) => p.spacing(0.5),
  outlineStyle: 'solid',
  outlineColor: (p) => p.palette.grey[200],
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
};

export const noDataTitleWrapper: SxStyle = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: (p) => p.spacing(25),
  height: (p) => p.spacing(5),
};
